// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/jwt/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
    },
  },
  // DASHBOARD
  dashboard: {
    root: (shopid) => `${ROOTS.DASHBOARD}/${shopid}`,
    one: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/one`,
    two: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/two`,
    three: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/three`,
    theme: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/theme`,
    group: {
      root: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/group`,
      five: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/group/five`,
      six: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/group/six`,
    },
    companies: {
      root: `${ROOTS.DASHBOARD}/shops`,
      new: `${ROOTS.DASHBOARD}/shops/new`,
      edit: (id) => `${ROOTS.DASHBOARD}/shops/${id}/edit`,
      manager: (id) => `${ROOTS.DASHBOARD}/shops/${id}/manager`,
    },
    notify: {
      shop: (id) => `${ROOTS.DASHBOARD}/shops/${id}/notify`,
    },
    payment: {
      shop: (id) => `${ROOTS.DASHBOARD}/shops/${id}/payment`,
    },
    services: {
      shop: (id) => `${ROOTS.DASHBOARD}/shops/${id}/services`,
    },
    employees: {
      shop: (id) => `${ROOTS.DASHBOARD}/shops/${id}/employees`,
    },
    historybooking: {
      list: (id) => `${ROOTS.DASHBOARD}/shops/${id}/historybooking`,
    },
    user: {
      list: (id) => `${ROOTS.DASHBOARD}/shops/${id}/user`,
    },
    referrals: {
      root: `${ROOTS.DASHBOARD}/referrals`,
    },
    affiliate: {
      admin: `${ROOTS.DASHBOARD}/affiliate/admin`,
    },
    cases: {
      root: `${ROOTS.DASHBOARD}/cases`,
    },
    chat: {
      root: (id) => `${ROOTS.DASHBOARD}/shops/${id}/chat`,
      new: (id) => `${ROOTS.DASHBOARD}/shops/${id}/chat/new`,
      view: (id, conversationKey) => `${ROOTS.DASHBOARD}/shops/${id}/chat/${conversationKey}`,
    },
    courses: {
      root: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/courses`,
      new: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/courses/new`,
      edit: (shopid, id) => `${ROOTS.DASHBOARD}/${shopid}/courses/${id}/edit`,
      lesson: (shopid, courseId, lessonId) => `${ROOTS.DASHBOARD}/${shopid}/courses/${courseId}/lesson/${lessonId}/edit`,
      settings: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/courses/settings`,
    },
    pages: {
      root: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/pages`,
      new: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/pages/new`,
      detail: (shopid, id) => `${ROOTS.DASHBOARD}/${shopid}/pages/${id}/edit`,
      settings: (shopid, id) => `${ROOTS.DASHBOARD}/${shopid}/pages/${id}/settings`,
    },
    forms: {
      root: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/forms`,
      new: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/forms/new`,
      detail: (shopid, fid) => `${ROOTS.DASHBOARD}/${shopid}/forms/${fid}`,
      edit: (shopid, fid) => `${ROOTS.DASHBOARD}/${shopid}/forms/${fid}/edit`,
    },
    reports: {
      root: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/reports`,
      detail: (shopid, id) => `${ROOTS.DASHBOARD}/${shopid}/reports/${id}`,
    },
    channels: {
      root: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/channels`,
    },
    club: {
      root: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/club`,
      new: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/club/new`,
      edit: (shopid, id) => `${ROOTS.DASHBOARD}/${shopid}/club/${id}/edit`,
      subscribers: (shopid, ids) => `${ROOTS.DASHBOARD}/${shopid}/club/subscribers/${ids}`,
    },
    usercard: {
      root: (sid) => `${ROOTS.DASHBOARD}/${sid}/usercard`,
    },
    general: {
      edit_page: (shopid, id) => `${ROOTS.DASHBOARD}/${shopid}/pages/${id}/edit`,
      articles: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/pages`,
      usercard: (shopid) => `${ROOTS.DASHBOARD}/${shopid}/usercard`,
      group_lock: (shopid, id) => `${ROOTS.DASHBOARD}/${shopid}/pages/${id}/grouplock`,
    },
  },
  // STUDENT
  student: {
    root: (shopid) => `/student/${shopid}`,
    dashboard: (shopid) => `/student/${shopid}/dashboard`,
    courses: (shopid) => `/student/${shopid}/courses`,
    course: (shopid, id) => `/student/${shopid}/course/${id}`,
    lesson: (shopid, courseId, lessonId) => `/student/${shopid}/course/${courseId}/lesson/${lessonId}`,
    saved: (shopid) => `/student/${shopid}/saved`,
    profile: (shopid) => `/student/${shopid}/profile`,
  },
  // PARTNERS
  partners: {
    offerta: '/partners/offerta',
  },
};

export const PATH_DASHBOARD = paths.dashboard;
